import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';
import {AttachedDocument} from '../documents';

class BankAccount extends DomainObject {
  nickname;
  accountNumber;
  transitNumber;
  institutionNumber;
  cheque;

  _relations = {
    cheque: AttachedDocument,
  };

  constructor(other) {
    super();

    makeObservable(this, {
      nickname: observable,
      accountNumber: observable,
      transitNumber: observable,
      institutionNumber: observable,
      cheque: observable
    });

    this.merge(other);
  }
}

export default BankAccount;
